export default __webpack_public_path__ + "static/media/myOrder.4520930b.svg";